var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-2 py-1 d-flex"},[_c('button',{staticClass:"btn btn-primary text-wrap",on:{"click":function($event){return _vm.data.event()}}},[_c('font-awesome-icon',{attrs:{"icon":_vm.data.icon}}),_vm._v(" "+_vm._s(_vm.data.title)+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }